var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { config } from '../../../../config/config';
import { UpdateCityCommand } from '../../../commands/hub/update.city.command';
import { HubFeed } from '../../../models/hub/hub.feed';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { EditCityModalActions } from './edit.city.modal.provider';
var EditCityModalComponent = /** @class */ (function (_super) {
    __extends(EditCityModalComponent, _super);
    function EditCityModalComponent(dialogRef, actions, hubApiService, imageService, formBuilder, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.formBuilder = formBuilder;
        _this.updateCityCommand = new UpdateCityCommand();
        _this.sizeLimit = config.eventImageSizeLimit;
        _this.feed = Object.assign({}, data);
        _this.selectedImageData = imageService.imageSourceUrl(_this.feed.cityImage, false);
        _this.createForm();
        return _this;
    }
    EditCityModalComponent.prototype.onImageChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reader, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.selectedImageFile = $event.srcElement.files[0];
                        if (!!!this.selectedImageFile) return [3 /*break*/, 2];
                        reader = new FileReader();
                        reader.onload = function (e) {
                            _this.selectedImageData = e.target['result']
                                ? e.target['result'].toString()
                                : null;
                        };
                        reader.readAsDataURL(this.selectedImageFile);
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFile(this.selectedImageFile)];
                    case 1:
                        _a.selectedImageFile = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    EditCityModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditCityModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.selectedImageFile) {
                    this.updateCityCommand.image = this.selectedImageFile;
                }
                this.updateCityCommand.cityTitle = this.feed.cityTitle;
                this.updateCityCommand.id = this.feed.id;
                this.hubApiService.updateCity(this.feed.hubName, this.updateCityCommand).subscribe(function (image) {
                    if (image) {
                        _this.actions.confirm(event, {
                            image: image.imageFileName,
                            cityTitle: _this.feed.cityTitle,
                        });
                    }
                    else {
                        _this.actions.confirm(event, { cityTitle: _this.feed.cityTitle });
                    }
                    _this.dialogRef.close();
                });
                return [2 /*return*/];
            });
        });
    };
    EditCityModalComponent.prototype.createForm = function () {
        this.cityForm = this.formBuilder.group({
            title: [null, []],
        });
    };
    return EditCityModalComponent;
}(BaseComponent));
export { EditCityModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.city.modal/edit.city.modal.component.ts.pre-build-optimizer.js